<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/transferaccountssh/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      :show="false"
    >
      <el-form-item label="转出ID">
        <el-input v-model="formModel.userId" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="转入ID">
        <el-input v-model="formModel.toId" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="formModel.status">
          <el-option
            v-for="item in status"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="操作时间">
        <el-date-picker
          v-model="formModel.date"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="userId"
        label="转出ID"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="fromName"
        label="转出姓名"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="fromPhone"
        label="转出手机号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="toId"
        label="转入ID"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="toName"
        label="转入姓名"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="toPhone"
        label="转入手机号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="amount"
        label="金额(元)"
        :formatter="formatterTableNumber"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="accountType"
        label="账户类型"
        :formatter="formatterTableacctType"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        :formatter="formatterStatus"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="操作时间"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="creatorId"
        label="操作人"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="操作"
        min-width="200"
        v-if="hasPerm('/transferaccountssh/sh')"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.status == 0">
            <el-button type="text" @click="openAddDialog(scope.row)"
              >审核</el-button
            >
          </div>
          <div v-else>已审核!</div>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      formDialogTitle="操作"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
      labelWidth="120px"
    >
      <el-form-item label="审核" prop="status">
        <el-radio-group v-model="dialogModel.status">
          <el-radio :label="2">通过</el-radio>
          <el-radio :label="3">驳回</el-radio>
        </el-radio-group>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";

import FinanceService from "service/FinanceService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "transferaccountssh",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  data() {
    return {
      formModel: {
        toId: "",
        userId: "",
        date: "",
        status: "",
      },
      dialogModel: {
        status: 2,
      },
      dialogRules: {
        status: [
          {
            required: true,
            message: "请选择",
          },
        ],
      },
      itemId: "",
      tableData: [],
      status: [
        {
          id: "",
          name: "全部",
        },
        {
          id: "0",
          name: "待审核",
        },
        {
          id: "2",
          name: "成功",
        },
        {
          id: "3",
          name: "驳回",
        },
      ],
      submitService: FinanceService.transferaccountsshList,
      params: {},
      page: {},
      isPage: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      if (this.formModel.date == null || this.formModel.date == "") {
        this.formModel.date = [];
      }
      const params = {
        toId: this.formModel.toId,
        userId: this.formModel.userId,
        status: this.formModel.status,

        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.formModel.date.length) {
        params.startDate = this.formModel.date[0];
        params.endDate = this.formModel.date[1];
      }
      return params;
    },
    dialogData() {
      const params = {
        status: this.dialogModel.status,
      };
      if (this.itemId) {
        params.id = this.itemId;
      }
      return params;
    },
    dialogService() {
      return FinanceService.transferaccountsshSh;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  methods: {
    load() {
      this.formModel = {
        date: "",
        status: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    openAddDialog(item) {
      this.itemId = item ? item.id : "";
      this.$refs.formDialog.open();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    dialogSuccess(res) {
      this.showSuccess(res.respMsg);
      this.$refs.formDialog.closeDialog();
      this.getList();
    },
    dialogClose() {
      this.dialogModel = {
        status: 2,
      };
      this.itemId = "";
    },
    formatterStatus(row, column, cellValue, index) {
      let value = "--";
      this.status.forEach((item) => {
        if (item.id == cellValue) {
          value = item.name;
        }
      });
      return value;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/TransferAccountsSh.vue